import { VehicleColour as Colour } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';

export interface VehicleColoursState extends EntityState<Colour> {}

export const vehicleColoursAdapter: EntityAdapter<Colour> = createEntityAdapter<Colour>({
  selectId: (colour: Colour) => colour.id
});

export const initialState: VehicleColoursState = vehicleColoursAdapter.getInitialState({ loading: true });

export const vehicleColoursSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleColours
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleColoursAdapter.getSelectors(
  vehicleColoursSelector
);
